import {
  getPointerText,
  getCurrentPointerVariant,
  getCurrentBoxVariant,
  getBoxStyleTag,
  getDefaultCoreHtml,
  getPointerCss,
  getPointerColor0,
} from ".";
import { pointerVariantNameToCssClass } from "../pointerVariant/pointerVariant";
import {
  hotspotSize,
  useSirvMediaViewerDefaultStylesIfBoxVarianIsEqualTo,
  useSirvMediaViewerDefaultStylesIfPointerVarianIsEqualTo,
} from "../../config";

export const getTemplateFromVariantStyles = (state, options = {}) => {
  const {
    hotspotIndex,
    pointerVariant = getCurrentPointerVariant(state),
    boxVariant = getCurrentBoxVariant(state),
  } = options;
  const pointerTemplate = getPointerTemplateFromVariantStyles(state, {
    hotspotIndex,
    pointerVariant,
  });
  const boxStyleTag =
    boxVariant === useSirvMediaViewerDefaultStylesIfBoxVarianIsEqualTo
      ? null
      : getBoxStyleTag(state, { boxVariant });
  return [pointerTemplate, boxStyleTag].join("\n").replace(/\s+/g, " ").trim();
};

export const getPointerTemplateFromVariantStyles = (state, options = {}) => {
  const { hotspotIndex, pointerVariant = getCurrentPointerVariant(state) } =
    options;
  let [pointerStructure, pointerStyleTag] = ["", ""];
  pointerStructure = getPointerStructure(state, {
    hotspotIndex,
    pointerVariant,
  });
  if (
    pointerVariant !== useSirvMediaViewerDefaultStylesIfPointerVarianIsEqualTo
  ) {
    let pointerCss = getPointerCss(state, { variant: pointerVariant });
    if (pointerCss) {
      const pointerColor0 = getPointerColor0(state);
      const color0CssVarName = `--${pointerVariantNameToCssClass(
        pointerVariant
      )}-color0`;
      const color0RegEx = new RegExp(
        `var\\(\\s*${color0CssVarName}\\s*\\)`,
        "gi"
      );
      const pointerPartStyle = pointerColor0
        ? pointerCss.replace(color0RegEx, pointerColor0)
        : pointerCss;
      pointerStyleTag = pointerPartStyle
        ? `<style>${pointerPartStyle}</style>`
        : "";
    }
  } else {
    pointerStyleTag += `<style>
    :root {
      --sirv-hotspot-size: ${hotspotSize[0]}px;
    }
    .sirv-text-pointer { 
width:fit-content;
min-width: var(--sirv-hotspot-size);
padding-inline: 5px;
white-space: nowrap;
box-sizing: border-box;
}

 .sirv-hotspot-pointer.pulsating-point.sirv-text-pointer::before {
    border-radius: var(--sirv-hotspot-size);
    z-index: -1;
 }

 .sirv-hotspot-pointer.pulsating-point.sirv-text-pointer::after {
    border-radius: var(--sirv-hotspot-size);
 }
    </style>
    `;
  }
  const pointerTemplate = [pointerStructure, pointerStyleTag].join("\n");
  return pointerTemplate;
};

function getPointerStructure(state, { hotspotIndex, pointerVariant }) {
  const text =
    hotspotIndex >= 0 ? getPointerText(state, { hotspotIndex }) : null;
  if (
    !pointerVariant ||
    pointerVariant === useSirvMediaViewerDefaultStylesIfPointerVarianIsEqualTo
  ) {
    return `<div class="pulsating-point sirv-hotspot-pointer sirv-text-pointer">${
      text ?? ""
    }</div>`;
  }
  const defaultCoreHtml = getDefaultCoreHtml(state, {
    variant: pointerVariant,
  });
  const pointerClassName = pointerVariantNameToCssClass(pointerVariant);
  return `
      <div class="${pointerClassName} pointer" >
        <div class="sirv-pointer-background" >
          <div class="sirv-pointer-core${text ? ' text-core"' : '"'}>
            ${text ? text : defaultCoreHtml}
          </div>
        </div>
      </div>
    `;
}
